import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import MessengerCustomerChat from 'react-messenger-customer-chat';
import StaticPostLayout from '../components/StaticPostLayout';
import InfoSection from '../components/TripInfo/grand-canyon-south-rim';
import MapSection from '../components/Maps/grand-canyon-south-rim';

class GrandCanyonSouthRim extends Component {
  render() {
    return (
      <>
        <Helmet>
          <title>Grand Canyon South Rim: 3-Day Hiking Guide</title>
          <meta name="description" content="3-day Grand Canyon South Rim itinerary: Bright Angel Trail, Rim Trail, Desert View Drive, and the Desert View Watchtower. The most iconic hike in America." />
          <meta property="og:title" content="Grand Canyon South Rim: 3-Day Hiking Guide" />
          <meta property="og:description" content="3-day Grand Canyon South Rim itinerary: Bright Angel Trail, Rim Trail, Desert View Drive, and the Desert View Watchtower. The most iconic hike in America." />
          <meta property="og:url" content="https://exploroff.com/itineraries/grand-canyon-south-rim" />
          <meta property="og:type" content="article" />
          <meta property="og:image" content="https://exploroff.com/img/grand-canyon-south-rim/grand-canyon.jpg" />
          <link rel="canonical" href="https://exploroff.com/itineraries/grand-canyon-south-rim" />
          <script type="application/ld+json">{JSON.stringify({
            "@context": "https://schema.org", "@type": "BlogPosting",
            headline: "Grand Canyon South Rim: 3-Day Hiking Guide",
            description: "3-day Grand Canyon South Rim itinerary covering Bright Angel Trail, Rim Trail, and Desert View Drive.",
            image: ["https://exploroff.com/img/grand-canyon-south-rim/grand-canyon.jpg"],
            author: { "@type": "Organization", name: "ExplorOFF" },
            publisher: { "@type": "Organization", name: "ExplorOFF", logo: { "@type": "ImageObject", url: "https://exploroff.com/img/favicon.png" } },
            mainEntityOfPage: { "@type": "WebPage", "@id": "https://exploroff.com/itineraries/grand-canyon-south-rim" }
          })}</script>
        </Helmet>
        <MessengerCustomerChat pageId="101590111335192" appId="695593052231950" />
        <StaticPostLayout
          title="Grand Canyon South Rim: 3-Day Hiking Guide"
          category="itineraries"
          slug="grand-canyon-south-rim"
          excerpt="The most iconic hike in America — Bright Angel Trail, Mather Point, and Desert View in three days."
          tags={['hiking', 'national park', 'american southwest']}
          readTime={10}
          mapComponent={<MapSection />}
          whereToStay={[
            { name: 'El Tovar Hotel', type: 'Historic Lodge · South Rim', url: 'https://www.booking.com/searchresults.html?ss=Grand+Canyon+Village%2C+Arizona' },
            { name: 'Bright Angel Lodge', type: 'NPS Lodge · South Rim', url: 'https://www.booking.com/searchresults.html?ss=Grand+Canyon+Village%2C+Arizona' },
            { name: 'Hotels in Tusayan', type: 'Gateway Town · 1 mile from entrance', url: 'https://www.booking.com/searchresults.html?ss=Tusayan%2C+Arizona' },
          ]}
        >
          <InfoSection />
        </StaticPostLayout>
      </>
    );
  }
}

export default GrandCanyonSouthRim;
